export default __webpack_public_path__ + "static/media/EN ERREUR.841932c5.svg";